module.exports = __webpack_public_path__ + "media/bell.828599bf.mp3";